import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

// import logoBlueSvg from "../assets/images/logo_blue.svg";
import logoBlue from "../assets/images/logo_blue.png";
import buttonHamburgerSvg from "../assets/images/icons/button_hamburger.svg";

import "../assets/css/product.scss";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef();
  const location = useLocation();

  // 바깥 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentPath = location.pathname;

  return (
    <div className="product-header" ref={menuRef}>
      <ul>
        <li>
          <a href="/">
            <img src={logoBlue} alt="" />
          </a>
        </li>

        <li className="menu">
          <div className={currentPath === "/" ? "on" : ""}>
            <a href="/">키즈다 소개</a>
          </div>
          <div className={currentPath === "/product" ? "on" : ""}>
            <a href="/product">구독</a>
          </div>
          <div className={currentPath === "/educlip" ? "on" : ""}>
            <a href="/educlip">에듀클립</a>
          </div>
        </li>

        <li className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          <img src={buttonHamburgerSvg} alt="" />
        </li>

        <li className={`mobile-slide-menu ${isOpen ? "open" : ""}`}>
          <div className="close-button" onClick={() => setIsOpen(false)}>
            &times;
          </div>
          <div className={currentPath === "/" ? "on" : ""}>
            <a href="/">키즈다 소개</a>
          </div>
          <div className={currentPath === "/product" ? "on" : ""}>
            <a href="/product">구독</a>
          </div>
          <div className={currentPath === "/educlip" ? "on" : ""}>
            <a href="/educlip">에듀클립</a>
          </div>
        </li>

        {isOpen && <div className="overlay" onClick={() => setIsOpen(false)} />}
      </ul>
    </div>
  );
}

export default Header;
